/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import {
    getLocalStorage,
    setSessionStorage
} from '../_helpers/localStorage.helper';

export const GET_HOME_PAGE_DATA = 'GET_HOME_PAGE_DATA';

export function getHomePageData() {
    return {type: GET_HOME_PAGE_DATA};
}

export const SET_HOME_PAGE_TITLE = 'SET_HOME_PAGE_TITLE';

export function setHomePageTitle(payload) {
    return {type: SET_HOME_PAGE_TITLE, payload: payload};
}

export const SET_LOGIN = 'SET_LOGIN';

export function setLogin (login) {
    setSessionStorage('login', JSON.stringify(login));
    return {type: SET_LOGIN, payload: login};
}

export const GET_TOKEN_SUCCESS = 'GET_TOKEN_SUCCESS';

export function getLoginTokenSuccess(token) {
    setSessionStorage('login', JSON.stringify(token));
    const loginObj = {};
    loginObj['token'] = token;
    return {type: GET_TOKEN_SUCCESS, payload: loginObj};
}


// WEBPACK FOOTER //
// ./src/_actions/home.actions.js